import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_VALUE = {
  nearestData: {},
  scrubTime: null
};
const TimelineContext = /*#__PURE__*/createContext(DEFAULT_VALUE);
function TimelineProvider({
  children,
  value
}) {
  return /*#__PURE__*/_jsx(TimelineContext.Provider, {
    value: value,
    children: children
  });
}
export { TimelineContext, TimelineProvider };